import { Material } from 'Types';

import { memoize } from 'utils/utils';

export const imageSrcByMaterial: Record<Material, string> = {
  [Material.A]: '/img/materials/face-grain-jpg/ash-vertical.jpg',
  [Material.B]: '/img/materials/face-grain-jpg/beech-vertical.jpg',
  [Material.BL]: '/img/materials/face-grain-jpg/bloodwood-vertical.jpg',
  [Material.BU]: '/img/materials/face-grain-jpg/bubinga-vertical.jpg',
  [Material.BY]: '/img/materials/face-grain-jpg/birch-yellow-vertical.jpg',
  [Material.CH]: '/img/materials/face-grain-jpg/chechen-vertical.jpg',
  [Material.C]: '/img/materials/face-grain-jpg/cherry-vertical.jpg',
  [Material.J]: '/img/materials/face-grain-jpg/jatoba-vertical.jpg',
  [Material.M]: '/img/materials/face-grain-jpg/maple-vertical.jpg',
  [Material.P]: '/img/materials/face-grain-jpg/padauk-vertical.jpg',
  [Material.PH]: '/img/materials/face-grain-jpg/purpleheart-vertical.jpg',
  [Material.S]: '/img/materials/face-grain-jpg/sapele-vertical.jpg',
  [Material.W]: '/img/materials/face-grain-jpg/walnut-vertical.jpg',
  [Material.WE]: '/img/materials/face-grain-jpg/wenge-vertical.jpg',
  [Material.YH]: '/img/materials/face-grain-jpg/yellowheart-vertical.jpg',
  [Material.Z]: '/img/materials/face-grain-jpg/zebrawood-vertical.jpg',
};

export const getMaterialImagePromise: (
  material: Material
) => Promise<HTMLImageElement> = memoize(
  (material: Material) => {
    return new Promise((resolve, reject) => {
      const image = getMaterialImage(material);

      image.onload = () => resolve(image);
      image.onerror = () => resolve(image);
    });
  },
  (material) => material
);

export const getMaterialImage: (material: Material) => HTMLImageElement =
  memoize(
    (material: Material) => {
      const image = new Image();
      image.src = imageSrcByMaterial[material];
      return image;
    },
    (material) => material
  );
